import styled from 'styled-components';
import { Divider } from 'antd';

export const MarginLayout = styled.div`
  margin-left: 10px;
`;

export const Header = styled.div`
  font-style: italic;
  color: #979797;
`;

export const StyledDivider = styled(Divider)`
  height: auto;
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  position: relative;
  overflow: hidden;
`;

export const ContentWrapper = styled.div`
  padding: 10px 0;
`;
